<template>
  <v-card>
    <v-card-title>{{ $t('application.payment') }}</v-card-title>
    <v-card-text>
      <FCCProperty translation="events.PaymentConfirmed">
        <template v-slot:header>
          <v-icon color="green" v-if="data.paymentConfirmed">check_circle</v-icon>
          <v-icon color="red" v-else>cancel</v-icon>
        </template>
      </FCCProperty>
      <FCCProperty translation="application.invoiceForDepartment">
        <template v-slot:header>
          <v-icon color="green" v-if="data.payment.invoiceForDepartment">check_circle</v-icon>
          <v-icon color="red" v-else>cancel</v-icon>
        </template>
      </FCCProperty>
      <FCCProperty :text="data.payment.invoiceAddress" translation="application.invoiceAddress" v-if="data.payment.invoiceForDepartment" />
      <FCCProperty :text="data.payment.taxNumber" translation="application.taxNumber" v-if="data.payment.invoiceForDepartment" />
    </v-card-text>
    <v-card-text v-if="data.applicationCycle.paymentByTransfer">
      <FCCProperty :text="data.payment.amount+' €'" translation="application.amount" />
      <v-alert :value="!data.paymentConfirmed" type="error" transition="scale-transition" >
        {{ $t("payment.instructions") }}
      </v-alert>
      <FCCProperty text="PROSTOVOLJNO GASILSKO DRUŠTVO RADOVLJICA" translation="payment.receiver" />
      <FCCProperty text="GORENJSKA CESTA 31, 4240 RADOVLJICA" translation="payment.address" />
      <FCCProperty text="SI56 1010 0004 3488 878" translation="IBAN" />
      <FCCProperty text="Intesa Sanpaolo d.d.  PE Radovljica" translation="payment.bank" />
      <FCCProperty text="BAKOSI2X" translation="BIC" />
      <FCCProperty :text="'OTHR FCS-' + data.title" translation="payment.subject" />
      <FCCProperty :text="data.payment.reference" translation="application.reference" />
    </v-card-text>
    <v-card-title>{{ $t('application.confirmations') }}</v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="this.data.payment.paymentConfirmations"
        hide-default-headers
        disable-pagination
        hide-default-footer
        disable-sorting
        class="elevation-1"
      >
        <template v-slot:item.filename="{item}">
          <a :href="'data:application/base64;base64,'+encodeURIComponent(item.confirmation)" :download="item.filename">
              {{ item.filename }}</a>
        </template>
        <template v-slot:item.confirmationSize="{item}">
          {{ item.confirmationSize | fileSize }}
        </template>
      </v-data-table>
      <br />
      <v-alert :value="uploadError" type="error" transition="scale-transition" >
        {{ $t("payment.uploadError") }}
      </v-alert>
      <form enctype="multipart/form-data" novalidate v-if="!data.paymentConfirmed">
        <input id='file' type="file"> (Max 10 MB)
      </form>
    </v-card-text>

    <v-card-actions>
      <v-btn @click="upload" color="success" v-if="!data.paymentConfirmed && data.applicationCycle.paymentByTransfer" :disabled="!showUpload">{{ $t('payment.uploadConfirmation') }}</v-btn>
      <v-btn @click="dialog = true" color="success" v-if="!data.paymentConfirmed && $store.getters['isAdministrator']">{{ $t('application.confirmPayment') }}</v-btn>
    </v-card-actions>

    <v-dialog v-model="dialog" persistent max-width="390">
      <v-card>
        <v-card-title class="v-card__title headline">{{ $t('application.confirmPaymentText') }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error darken-1" @click="dialog = false">{{ $t('ctrl.close') }}</v-btn>
          <v-btn color="success darken-1" @click="confirmYes()">{{ $t('ctrl.confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VTextField,
    VCardActions,
    VCardText,
    VCardTitle,
    VDataTable,
    VDialog,
    VAlert
  } from 'vuetify/lib'
  import FCCProperty from '../FCCProperty'
  import FCCApplicationStatus from '../FCCApplicationStatus'
  import fccapi from '../../fccapi.js'

  export default {
    name: 'FCCApplicationPayment',
    props: {
      data: Object,
      reload: Function
    },
    data: function(){
      return {
        dialog: false,
        isInitial: true,
        uploadError: false,
        showUpload: true
      };
    },
    computed: {
      headers: function(){
        return [
          { text: this.$t('ctrl.file'), value: 'filename', align: 'left' },
          { text: this.$t('ctrl.size'), value: 'confirmationSize', align: 'left' },
        ]
      }
    },
    methods: {
        confirmYes: function(){
          this.dialog = false;
          fccapi.post(`payments/${this.data.payment.id}/confirm`, null).then(r => {
            console.log(r);
            this.reload();
          }).catch(e => {
            this.$store.dispatch('reportError', e.response.status);
          });
        },
        upload: function(){
          var formData = new FormData();
          var imagefile = document.querySelector('#file');
          formData.append("image", imagefile.files[0]);
          this.uploadError = false;
          this.showUpload = false;
          fccapi.upload(`payments/${this.data.payment.id}/upload`, formData).then(d =>{
            console.log(d)
            this.reload();
            this.showUpload = true;
          }).catch(r=>{
            console.log(r)
            this.uploadError = true;
            this.showUpload = true;
          })
        }
    },
    components: {
        VCard,
        VTooltip,
        VTextField,
        VCardActions,
        VCardText,
        FCCApplicationStatus,
        VDataTable,
        VDialog,
        VCardTitle,
        VAlert,
        FCCProperty
    }
  }
</script>
<style>
  .tag{
    flex: 0 0 130px;
  }
  .val{
    flex: 1;
    margin-bottom: 10px;
  }
</style>